import { gql } from 'apollo-boost';

import { MESSAGE_FRAGMENT } from '../fragments/message-fragment';
import { SYSTEM_CHAT_USER_FRAGMENT } from '../fragments/system-chat-user-fragment';

export const ADMIN_CONVERSATION_CREATE = gql`
  ${MESSAGE_FRAGMENT}
  ${SYSTEM_CHAT_USER_FRAGMENT}
  mutation($input: AdminConversationCreateInput!) {
    admin_conversation_create(input: $input) {
      conversation {
        id
        updated_at
        business_unread_messages_count
        last_message_sent
        last_message {
          ...messageFragment
        }
        ...systemChatUserKeys
      }
    }
  }
`;
